import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { selectors as settingsSelectors } from 'state/settings';

import FeatureToggleContext from 'components/feature-toggle/context';

const enhance = compose(
  connect((state) => ({
    features: settingsSelectors.getFeatures(state),
  }))
);

const FeatureToggleProvider = ({ features, children }) => (
  <FeatureToggleContext.Provider value={features}>
    {children}
  </FeatureToggleContext.Provider>
);

FeatureToggleProvider.propTypes = {
  features: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
};

export default enhance(FeatureToggleProvider);
